import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-emp-extend-popup',
  templateUrl: './emp-extend-popup.component.html',
  styleUrls: ['./emp-extend-popup.component.scss'],
})
export class EmpExtendPopupComponent implements OnInit {
  constructor(private dialogRef: MatDialogRef<EmpExtendPopupComponent>) {}

  ngOnInit(): void {}

  onNoClick() {
    this.dialogRef.close();
  }
}
